import Vue from "vue";

export const filterPrice = (value: string | number, defaultValue: string | number = 0): string => {
  if (value == null) return "";
  if (!value) return "0.00";
  if (typeof value === "string") {
    value = parseFloat(value.replace(" ", "").replace(",", "."));
  }
  if (isNaN(value as number)) {
    if (typeof defaultValue === "string") {
      value = parseFloat(defaultValue.replace(" ", "").replace(",", "."));
    } else {
      value = defaultValue;
    }
  }
  return (Math.round(value * 100) / 100).toFixed(2);
};

Vue.filter("price", filterPrice);
